<template>
  <div class="container py-3">
    <!-- 提醒任務已取消訊息 -->
    <AlertMessage variant="secondary">
      <h4 class="mb-0 text-secondary text-spacing-5 py-1">
        <Icon
          :icon="CompleteChecked"
          width="1.2em"
          height="1.2em"
          class="me-2" />
        <span class="mb-0 align-middle fw-bolder">服務未執行或已取消</span>
      </h4>
    </AlertMessage>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Icon from "@/components/Icon.vue";
import { CompleteChecked } from "@/utility/icon";
import AlertMessage from "@/components/AlertMessage.vue";

export default defineComponent({
  name: "OrderDetailView",
  components: {
    Icon,
    AlertMessage,
  },
  async setup() {
    return {
      // icons
      CompleteChecked,
    };
  },
});
</script>
